import { createActionTypes } from 'zeal-redux-utils'

export default createActionTypes('debate', [
  'FETCH_QUESTIONS_FAILURE',
  'FETCH_QUESTIONS_REQUEST',
  'FETCH_QUESTIONS_SUCCESS',
  'SELECT_QUESTION',
  'QUESTION_REQUIRED',
  'RESET_BUILDER',
  'SELECT_PART',
  'UPDATE_PART_ELEMENT_VALUE',
  'UPDATE_PART_LOCATION',
  'UPDATE_FORM_VALUES'
])



// WEBPACK FOOTER //
// ./client/modules/debate/constants/actionTypes.js